import { useRef, useState } from "react";
import { toast } from 'react-toastify';
import { AttachmentItem } from "../../../../../components/attachmentItem/AttachmentItem";
import UploadComponent from "../../../../../components/upload/uploadComponent";
import ButtonLoading from "../../../../../components/buttonLoading/buttonLoading";

export function AttachmentsComponent({ files, service, id, username }) {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const uploadRef = useRef();

    const handleSendAttachment = async () => {
        setLoading(true);
        const formData = new FormData();
        for (let file of selectedFiles) {
            formData.append('files', file);
        }
        try {
            await service.addAttchamentComment(id, username, formData);
            setSelectedFiles([]);
            toast.success("Arquivos enviados");
            setLoading(false);
            limparArquivos();
        } catch {
            toast.error("Não foi possível anexar arquivo a este chamado. Tente novamente ou contate o administrador!");
            setLoading(false);
        }
    };

    const limparArquivos = () => {
        if (uploadRef.current) {
            uploadRef.current.clearAll();
        }
    };

    return (
        <>
            <div className="bg-white rounded-lg shadow p-6">
                <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                    <i className="fas fa-plus-square mr-2 text-indigo-600"></i> Adicionar Arquivos
                </h3>
                <div className="space-y-3 ">
                    <UploadComponent ref={uploadRef} onChange={setSelectedFiles} />
                    {selectedFiles.length > 0 &&
                        <div className='flex justify-center gap-1'>
                            <ButtonLoading
                                type="button"
                                color="green"
                                label="Confirmar Envio de Arquivo"
                                loading={loading}
                                onClick={handleSendAttachment}>
                                Confirmar envio
                            </ButtonLoading>
                        </div>
                    }
                </div>
            </div>
            <div className="bg-white rounded-lg shadow p-6">
                <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                    <i className="fas fa-paperclip mr-2 text-indigo-600"></i> Anexos
                </h3>
                {files.length === 0 &&
                    <p className="text-sm font-medium text-gray-800 truncate">
                        Nenhum arquivo foi anexado neste chamado
                    </p>
                }
                <div className="attachaments-container p-4 overflow-y-auto">
                    <div className="space-y-3 ">
                        {files.length > 0 && (
                            <>
                                {files.map((attachment) => (
                                    <AttachmentItem filename={attachment} service={service} />
                                ))}
                            </>
                        )}

                        {selectedFiles.length > 0 &&
                            <div className='flex justify-center gap-1'>
                                <ButtonLoading
                                    type="button"
                                    color="green"
                                    label="Confirmar Envio de Arquivo" onClick={handleSendAttachment}>
                                    Confirmar envio
                                </ButtonLoading>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}